import { FC } from 'react';

type Props = {
};

const FragmentIcon: FC<Props> = ({}) => (
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M7 15V5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H9C8.46957 17 7.96101 16.7891 7.58594 16.4141C7.25765 16.0858 7.05515 15.6553 7.00977 15.1973L7 15Z" fill="#C95C75"/>
        <path d="M15 19V9H5C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7H15L15.1973 7.00977C15.6553 7.05515 16.0858 7.25765 16.4141 7.58594C16.7891 7.96101 17 8.46957 17 9V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19Z" fill="#C95C75"/>
    </svg>
);

export default FragmentIcon;import { FC } from 'react';

type Props = {
};

const FragmentIcon: FC<Props> = ({}) => (
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M7 15V5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H9C8.46957 17 7.96101 16.7891 7.58594 16.4141C7.25765 16.0858 7.05515 15.6553 7.00977 15.1973L7 15Z" fill="#C95C75"/>
        <path d="M15 19V9H5C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7H15L15.1973 7.00977C15.6553 7.05515 16.0858 7.25765 16.4141 7.58594C16.7891 7.96101 17 8.46957 17 9V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19Z" fill="#C95C75"/>
    </svg>
);

export default FragmentIcon;